/**
 * Impression. Tout passe par un iframe caché plutôt qu'une fenêtre : sur iPad
 * une popup se fait bloquer, et l'application ne doit jamais perdre son état
 * de caisse pour imprimer un ticket.
 */

const POLICE = "'Archivo', system-ui, sans-serif"

export function imprimer(titre: string, corps: string, styles: string): void {
  const ancien = document.getElementById('cadre-impression')
  ancien?.remove()

  const cadre = document.createElement('iframe')
  cadre.id = 'cadre-impression'
  cadre.setAttribute('aria-hidden', 'true')
  cadre.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden'
  document.body.appendChild(cadre)

  const doc = cadre.contentDocument
  if (!doc) return

  doc.open()
  doc.write(`<!doctype html><html lang="fr"><head><meta charset="utf-8"><title>${echapper(titre)}</title>
<link rel="stylesheet" href="/polices/archivo.css">
<style>
  * { box-sizing: border-box; }
  body { margin: 0; font-family: ${POLICE}; color: #000; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  .titre { font-weight: 800; }
  .droite { text-align: right; }
  ${styles}
</style></head><body>${corps}</body></html>`)
  doc.close()

  const lancer = () => {
    cadre.contentWindow?.focus()
    cadre.contentWindow?.print()
    // On laisse le temps au dialogue système de s'ouvrir avant de nettoyer.
    window.setTimeout(() => cadre.remove(), 60_000)
  }

  if (doc.readyState === 'complete') window.setTimeout(lancer, 150)
  else cadre.onload = () => window.setTimeout(lancer, 150)
}

export function echapper(texte: string): string {
  return texte
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}
